import { db, firebase } from "../Config";

/**
 * Entidad Sesion en Firestore (Subcolección de Pacientes):
 * Path: pacientes/{pacienteId}/sesiones/{sesionId}
 * 
 * - atencionId (string): ID de la atención clinical activa
 * - prestacionId (string): ID del tratamiento ejecutado
 * - fecha (Timestamp): Fecha de ejecución
 * - nota (string): Nota clínica de la sesión
 * - especialistaId (string): Email del especialista
 */

export const crearSesion = async (pacienteId, empresaId, sesionData) => {
    try {
        const sesionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("sesiones").doc();
        const nuevaSesion = {
            ...sesionData,
            estado: "AGREGADO", // Estado inicial
            fecha: firebase.firestore.FieldValue.serverTimestamp(),
        };
        await sesionRef.set(nuevaSesion);
        return { id: sesionRef.id, ...nuevaSesion };
    } catch (error) {
        console.error("Error creating session bridge document:", error);
        throw error;
    }
};

export const eliminarSesion = async (pacienteId, atencionId, prestacionId, empresaId) => {
    try {
        const snapshot = await db.collection("empresas")
            .doc(empresaId)
            .collection("pacientes")
            .doc(pacienteId)
            .collection("sesiones")
            .where("atencionId", "==", atencionId)
            .where("prestacionId", "==", prestacionId)
            .get();

        const batch = db.batch();
        snapshot.docs.forEach(doc => {
            batch.delete(doc.ref);
        });
        await batch.commit();
        return true;
    } catch (error) {
        console.error("Error deleting session bridge documents:", error);
        throw error;
    }
};

export const fetchSesionesByAtencion = async (pacienteId, atencionId, empresaId) => {
    try {
        const snapshot = await db.collection("empresas")
            .doc(empresaId)
            .collection("pacientes")
            .doc(pacienteId)
            .collection("sesiones")
            .where("atencionId", "==", atencionId)
            .get();

        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error("Error fetching sessions by attention:", error);
        throw error;
    }
};

export const fetchSesionesRealizadas = async (pacienteId, empresaId) => {
    try {
        const snapshot = await db.collection("empresas")
            .doc(empresaId)
            .collection("pacientes")
            .doc(pacienteId)
            .collection("sesiones")
            .where("estado", "==", "REALIZADO")
            .orderBy("fecha", "desc")
            .get();

        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error("Error fetching executed sessions:", error);
        throw error;
    }
};

export const updateSesionNota = async (pacienteId, sesionId, nota, empresaId) => {
    try {
        await db.collection("empresas")
            .doc(empresaId)
            .collection("pacientes")
            .doc(pacienteId)
            .collection("sesiones")
            .doc(sesionId)
            .update({ 
                nota,
                estado: "REALIZADO" // Cambiar estado a REALIZADO al agregar nota
            });
        return true;
    } catch (error) {
        console.error("Error updating session note:", error);
        throw error;
    }
};

export const updateSesionExecution = async (pacienteId, sesionId, executionData, empresaId) => {
    try {
        // executionData can contain caras: [] and/or pilares: []
        await db.collection("empresas")
            .doc(empresaId)
            .collection("pacientes")
            .doc(pacienteId)
            .collection("sesiones")
            .doc(sesionId)
            .update({ 
                ...executionData,
                estado: "REALIZADO" // Cambiar estado a REALIZADO al ejecutar acciones
            });
        return true;
    } catch (error) {
        console.error("Error updating session execution data:", error);
        throw error;
    }
};
